if (!customElements.get('wlsn-5050-with-brag')) {
    class WLSN5050WithBrag extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                openClass: 'open',
                isMobile: window.innerWidth < 768,
                accordion: 'js-wlsn-5050-with-brag-accordion',
            };

            this.elements = {
                accordions: this.querySelectorAll(`.${this.classes.accordion}`),
            };
        }

        connectedCallback() {
            this.toggle();
        }

        toggle() {
            if(this.classes.isMobile && this.elements.accordions.length > 0) {
                this.elements.accordions.forEach(accordion => {
                    accordion.addEventListener('click', ()=>{
                        accordion.classList.toggle(this.classes.openClass);
                    });
                })
        }
    }
    }

    customElements.define('wlsn-5050-with-brag', WLSN5050WithBrag);
}
